import { render, staticRenderFns } from "./FooterApps.vue?vue&type=template&id=22e0933e&scoped=true"
import script from "./FooterApps.vue?vue&type=script&lang=js"
export * from "./FooterApps.vue?vue&type=script&lang=js"
import style0 from "./FooterApps.vue?vue&type=style&index=0&id=22e0933e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e0933e",
  null
  
)

export default component.exports